import { FC } from "react";

import { FormInfobox, FormInfoboxProps } from "@/forms-design-system/FormInfobox/FormInfobox";
import { useTranslate } from "@/hooks/useTranslate";
import { Success } from "@/icons/outlined";

type ThemedYoureHelpingZeffyCoverFeesInfoboxProps = Omit<
  FormInfoboxProps,
  "icon" | "title" | "description" | "variant"
> & {
  organizationName: string;
};

export const ThemedYoureHelpingZeffyCoverFeesInfobox: FC<ThemedYoureHelpingZeffyCoverFeesInfoboxProps> = ({
  organizationName,
  ...rest
}) => {
  const { t } = useTranslate();

  return (
    <FormInfobox
      icon={<Success />}
      variant="emphasis"
      description={t("common", "payment.positiveZeffyCoversFees", { orgName: organizationName })}
      {...rest}
    />
  );
};
